import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () => import("../views/TestPage.vue")
  },
  {
    path: "/idchip",
    component: () => import("../views/IDChipView.vue")
  },
  {
    path: "/software",
    component: () => import("../views/SoftwareView.vue")
  },
  {
    path: "/test",
    component: () => import("../views/TestPage.vue")
  },
  {
    path: "/test/review",
    component: () => import("../views/TestReviewPage.vue")
  },
  {
    path: "/privacy-consent",
    component: () => import("../views/PrivacyConsent.vue")
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
